<!--
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-12-04 17:12:56
 * @FilePath: \frontend\src\App.vue
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { ElNotification, ElMessage } from 'element-plus';
import { mapGetters } from 'vuex';
// import { getTopic } from './utils/mqtt';
// import { topicType } from './utils/const';
// import { publishTopic } from '@/utils/mqtt';

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      // keepAliveInterval: null,
    };
  },
  computed: {
    ...mapGetters(['isShowNotification', 'pubsubDisconnected']),
    /*
    lang: {
      get() {
        return this.$store.state.system.lang;
      },
      set(value) {
        this.$store.dispatch('system/setLang', value);
      },
    },
    */
  },
  async created() {
    // MQTT Keep Alive
    // this.timeInterval = setInterval(() => {
    //   if (this.$route.path !== '/login') {
    //     const clientId = getPubSubClientId();
    //     const mqttTopic = getTopic(topicType.keepAlive, {
    //       tenant: store.getters.tenantId,
    //       target: clientId,
    //     })
    //     const mqttData = {
    //       target: 'keep-alive',
    //       payload: {},
    //     };
    //     publishTopic(mqttTopic, mqttData);
    //   }
    // }, 30 * 1000);
  },
  mounted() {
    // this.initLang();
  },
  beforeUnmount() {
    // clearInterval(this.keepAliveInterval);
  },
  methods: {
    async reload() {
      await this.$store.dispatch('app/setPubSubReloading', true);
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        // Hub detect disconnection with a delay
        //  revert setPubSubReloading=false with delay (exclude reloading disconnection)
        setTimeout(() => {
          this.$store.dispatch('app/setPubSubReloading', false);
          if (this.pubsubDisconnected) {
            this.$store.dispatch('app/setPubSubDisconnected', false);
          }
        }, 500);
      });
    },
    notify(data) {
      data.customClass = 'notify';
      if (data.type === 'success') {
        if (this.isShowNotification) {
          ElNotification(data);
        }
      } else {
        ElNotification(data);
      }
    },
    message(data) {
      data.customClass = 'notify';
      return ElMessage(data);
    },
    /*
    initLang() {
      const DEFAULT_LANG = 'en'; // 默认语言（当前使用的语言）
      const LOCALE_KEY = 'local';

      const locales = {
        ja: '',
        en: '',
        zh: '',
      };
      let lang = localStorage.getItem(LOCALE_KEY);
      if (locales[lang] === undefined) {
        lang = DEFAULT_LANG;
      }

      this.lang = lang;
    },
    */
  },
};

Date.prototype.Format = function (fmt) {
  // author: meizz
  const obj = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    const matchedStr = fmt.match(/(?<y>y+)/).groups['y'];
    fmt = fmt.replace(matchedStr, (this.getFullYear() + '').substring(4 - matchedStr)); // matchedStr.length <= 4
  }
  for (const key in obj) {
    const matchKey = key.replace('+', '');
    if (new RegExp('(' + key + ')').test(fmt)) {
      const matchedStr = fmt.match(new RegExp('(?<' + matchKey + '>' + key + ')')).groups[matchKey];
      fmt = fmt.replace(
        matchedStr,
        matchedStr.length === 1 ? obj[key] : ('00' + obj[key]).substring(('' + obj[key]).length)
      );
    }
  }
  return fmt;
};

// String.prototype.toFirstUpperCase = function () {
//   var str = this.valueOf();
//   return str.substring(0, 1).toUpperCase() + str.substring(1);
// };
</script>

<style>
::-webkit-scrollbar {
  width: 16px;
  height: 16px;
  background-color: #fff;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.3);
}

.notify {
  z-index: 99999 !important;
}
</style>
